import { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';

import {
  headersFluxosProaqFases as headers,
  valoresExibidosOffCanvasFluxoProaqFase as valoresExibidos,
} from './auxiliarFluxosProaq';
import SubAbasFluxosProaq from './subabasFluxosProaq';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import Modal from '../../../../components/Modal';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import {
  EnumOption,
  LogData,
  TipoModalidade,
} from '../../../../modules/types/types';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useUnidadeDAF } from '../../../../services/enum/useUnidadeDaf';
import {
  getFasesByFluxoProaq,
  getFluxoProaq,
  getFluxoProaqByModalidadeCoordenacaoBool,
} from '../../../../services/fluxo/fluxoProaqService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { getAllTipoModalidade } from '../../../../services/processosAquisitivos/proaqService';
import {
  formataNomeMeioSiglas,
  formatDate,
  transformarEnumOptionValueEmLabel,
} from '../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../utils/swal';

export default function FluxoProaqFicha() {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Adm')?.value || '0',
  );

  const canSave = isActionAllowed(MODULO, 'update', papelUsuarioOptions);

  const theme = useTheme();

  const navigate = useNavigate();
  const location = useLocation();
  const locationData = location.state;
  const params = useParams();
  const fichaID = String(params.id);

  const unidadeDAF = useUnidadeDAF();
  // const modalidade = useProaqModAquisicao();

  const bin = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'Ativo' },
    { value: 2, label: 'Inativo' },
  ];

  const [statusOriginal, setStatusOriginal] = useState<'1' | '2'>('2'); // '1' para Ativo, '2' para Inativo

  //Dados do componente
  let logs = {};
  let subAbas;

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formFluxoProaq, setFormFluxoProaq] = useState({
    status: '1',
    modalidade: locationData ? locationData.formFluxoProaq.modalidade : 0,
    coordenacao: locationData ? locationData.formFluxoProaq.coordenacao : 0,
    nomeModelo: locationData ? locationData.formFluxoProaq.nomeModelo : '',
    descricao: '',
    processoSei: '',
    documentoSei: '',
    link: '',
    observacoes: '',
    nProaq: 0,
    usuarioId: userID,
  });

  const [logFluxoFase, setLogFluxoFase] = useState<LogData>();
  const [formFluxoFase, setFormFluxoFase] = useState({
    ordem: 0,
    estimativaDias: 0,
    nomeFase: '',
    areaResponsavel: locationData
      ? locationData.formFluxoProaq.coordenacao
      : 'SisAF',
    descricao: '',
    observacoes: '',

    fluxoProaqId: fichaID ? parseInt(fichaID, 10) : 0,
    usuarioId: userID,
  });

  const [fluxoFaseId, setFluxoFaseId] = useState('');
  const [updatingFluxoFase, setUpdatingFluxoFase] = useState(false);
  const [proximaFase, setProximaFase] = useState<number>(1);

  const [fasesData, setFasesData] = useState<any[]>([]);
  const [tipoModalidadeData, setTipoModalidadeData] = useState<
    TipoModalidade[]
  >([]);
  const [temProaqAssociado] = useState(false);
  const [showModalFluxoFase, setShowModalFluxoFase] = useState<boolean>(false);

  // Buscar Dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getFluxoProaq(id);
      const fasesData = await getFasesByFluxoProaq(id);
      const tipoModalidadeData = await getAllTipoModalidade();
      setTipoModalidadeData(tipoModalidadeData);
      setLogData(registroData);
      setFormFluxoProaq({
        status: registroData.status === 'S' ? '1' : '2',
        modalidade: registroData.modalidade,
        coordenacao: registroData.coordenacao,
        nomeModelo: registroData.nomeModelo,
        descricao: registroData.descricao,
        processoSei: registroData.processoSei,
        documentoSei: registroData.documentoSei,
        link: registroData.link,
        observacoes: registroData.observacoes,
        nProaq: registroData.nProaq,
        usuarioId: userID,
      });
      setFasesData(fasesData);
      if (fasesData.length > 0) {
        setProximaFase(fasesData.length + 1);
      }
      setStatusOriginal(registroData.status === 'S' ? '1' : '2');
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID);
    }, [fichaID]);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };
    //Subabas
    subAbas = SubAbasFluxosProaq(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/adm/tabelasdeapoio/fluxoproaq/ficha/dadosgerais`,
      },
    ];
  }

  const tipoModalidadeOptions: EnumOption[] = [
    { value: '0', label: 'Não informado' },
    ...tipoModalidadeData.map((item: TipoModalidade) => ({
      value: item.id.toString(),
      label: item.nomeTipoModalidade,
    })),
  ];

  const isModeloPadraoOuAssociadoAProaq = () => {
    let isModeloUtilizado = false;
    if (fichaID === '1' || temProaqAssociado) {
      isModeloUtilizado = true;
    } else {
      isModeloUtilizado = false;
    }
    return isModeloUtilizado;
  };

  const tableDataFases = fasesData.map((item) => ({
    id: item.id,
    ordem: item.ordem,
    estimativaDias: item.estimativaDias,
    areaResponsavel: item.areaResponsavel,
    nomeFase: item.nomeFase,
  }));

  const offCanvasFases = fasesData.map((item) => {
    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      nomeFase: item.nomeFase,
      areaResponsavel: item.areaResponsavel ?? '',
      ordem: item.ordem,
      estimativaDias: item.estimativaDias,
      descricao: item.descricao,
      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });
  //Funções Handle
  const handleShowModalFluxoFase = () => {
    setShowModalFluxoFase((prev) => !prev);
    handleClearFormFluxoFase();
  };

  const handleClearFormFluxoFase = () => {
    setFormFluxoFase({
      ordem: 0,
      estimativaDias: 0,
      nomeFase: '',
      areaResponsavel: '',
      descricao: '',
      observacoes: '',

      fluxoProaqId: fichaID ? parseInt(fichaID, 10) : 0,
      usuarioId: userID,
    });
  };

  const handleRowClickFluxoFase = (id: string) => {
    setFluxoFaseId(id);
    setUpdatingFluxoFase(true);
    handleShowModalFluxoFase();
    const filteredItem = fasesData.find((item) => item.id == id);
    if (filteredItem) {
      setDadosFluxoFase(filteredItem);
      setLogFluxoFase({
        id: filteredItem.id,
        usuarioRegistro: filteredItem.usuarioRegistro.nomeCompleto || '',
        usuarioAtualizacao: filteredItem.usuarioAtualizacao.nomeCompleto || '',
        dataRegistro: filteredItem.dataRegistro,
        dataAtualizacao: filteredItem.dataUltimaAtualizacao,
        nEdicoes: filteredItem.nEdicoes,
      });
    }
  };

  const setDadosFluxoFase = (item: any) => {
    setFormFluxoFase({
      ordem: item.ordem,
      descricao: item.descricao,
      nomeFase: item.nomeFase,
      estimativaDias: item.estimativaDias,
      areaResponsavel: item.areaResponsavel,
      observacoes: item.observacoes,

      fluxoProaqId: item.fluxoProaqId,
      usuarioId: userID,
    });
  };
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    setFormFluxoProaq((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeStatus = async (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const newStatus = event.target.value;
    // Atualiza o form se passou pela verificação
    setFormFluxoProaq((prevState) => ({
      ...prevState,
      status: newStatus,
    }));
  };

  const handleChangeFluxoFase = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { name, value } = event.target;

    setFormFluxoFase((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.status) {
      errors.push('<b>Status</b> é obrigatório.');
    }

    if (!form.modalidade) {
      errors.push('<b>Modalidade de Aquisição</b> é obrigatório.');
    }

    if (!form.coordenacao) {
      errors.push('<b>Unidade DAF</b> é obrigatório.');
    }

    if (!form.nomeModelo) {
      errors.push('<b>Nome do Modelo</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const transformFormToSend = (form: any) => {
    return {
      ...form,
      status: form.status === '1' ? 'S' : 'N',
      modalidade: parseInt(form.modalidade, 10),
      coordenacao: parseInt(form.coordenacao, 10),
    };
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formFluxoProaq);
      if (!isFormValid) return;

      const formToSend = transformFormToSend(formFluxoProaq);

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/fluxoProaq/`, formToSend);

      swalSave();
      setTimeout(
        () =>
          navigate(
            `/daf/adm/tabelasdeapoio/fluxoproaq/ficha/${response.data.registro.id}/dadosgerais`,
          ),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      // swalErro('Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      if (fichaID === '1') {
        swalAttention('O <b>Modelo Padrão</b> não pode ser modificado!');
        return;
      }

      // Verificar se o formulário é válido
      const isFormValid = validateForm(formFluxoProaq);
      if (!isFormValid) return;

      const formToSend = transformFormToSend(formFluxoProaq);

      const response = await httpClient.patch(
        `/api/fluxoproaq/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/fluxoproaq/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/adm/tabelasdeapoio');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  const validateFormFluxoFase = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.numeroOrdem) {
      errors.push('<b>Nº Ordem</b> é obrigatório.');
    }

    if (!form.estimativaDias) {
      errors.push('<b>Estimativa - dias</b> é obrigatório.');
    }

    if (!form.nomeFase) {
      errors.push('<b>Nome da Fase</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const transformFormToSendFluxoFase = (form: any) => {
    return {
      ...form,
      nome: form.nomeFase,
      numeroOrdem: updatingFluxoFase ? formFluxoFase.ordem : proximaFase,
      estimativaDias: parseInt(form.estimativaDias, 10),
      areaResponsavel: transformarEnumOptionValueEmLabel(
        formFluxoProaq.coordenacao,
        unidadeDAF,
      ),
      fluxoProaqId: parseInt(fichaID, 10),
    };
  };

  const handleCreateFluxoFase = async () => {
    try {
      const formToSend = transformFormToSendFluxoFase(formFluxoFase);

      // Verificar se o formulário é válido
      const isFormValid = validateFormFluxoFase(formToSend);
      if (!isFormValid) return;

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(
        `/api/fluxoproaqfase/`,
        formToSend,
      );

      swalSave();
      fetchData(fichaID);
      setTimeout(() => handleShowModalFluxoFase(), 2500);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swalErro(error.response?.data.message);
    }
  };

  const handleUpdateFluxoFase = async () => {
    try {
      const formToSend = transformFormToSendFluxoFase(formFluxoFase);

      // Verificar se o formulário é válido
      const isFormValid = validateFormFluxoFase(formToSend);
      if (!isFormValid) return;

      const response = await httpClient.patch(
        `/api/fluxoproaqfase/${fluxoFaseId}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(fichaID);
      setTimeout(() => handleShowModalFluxoFase(), 2000);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
    }
  };

  const handleDeleteFluxoFase = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/fluxoproaqfase/${fluxoFaseId}`);
        swalDeleteConfirm();
        fetchData(fichaID);
        setTimeout(() => handleShowModalFluxoFase(), 2500);
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  const [proaqBool, setProaqBool] = useState(false);
  useEffect(() => {
    const nProaq = formFluxoProaq.nProaq;

    if (nProaq > 0) {
      setProaqBool(true);
    }
  }, [formFluxoProaq.nProaq]);

  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const branco = 'white';

    const status = Number(formFluxoProaq.status);

    const newStatusStyle = {
      backgroundColor: status === 0 ? branco : status === 1 ? verde : vermelho,
    };

    setStatusStyle(newStatusStyle);
  }, [formFluxoProaq.status]);

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/adm/fluxosproaqs"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>
      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} entity="TB_FLUXO_PROAQ" id={Number(fichaID)} />

          <BoxConteudo boxTitulo="Dados do Fluxo">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="150px">
                <SelectInput
                  name="status"
                  options={bin}
                  label="Status"
                  value={formFluxoProaq.status}
                  onChange={handleChangeStatus}
                  style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol
                width="100px"
                helpText="Número de Processos Aquisitivos associados a este modelo de fluxo de processo aquisitivo."
              >
                <Input
                  id="nProaq"
                  name="nProaq"
                  label="Proaqs"
                  value={formFluxoProaq.nProaq}
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly={true}
                />
              </CustomCol>

              <CustomCol width="250px">
                <SelectInput
                  // disabled={isModeloPadraoOuAssociadoAProaq()}
                  name="modalidade"
                  options={tipoModalidadeOptions}
                  label="Modalidade de Aquisição"
                  value={formFluxoProaq.modalidade}
                  onChange={handleChange}
                  disabled={true}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  // disabled={isModeloPadraoOuAssociadoAProaq()}
                  name="coordenacao"
                  options={unidadeDAF}
                  label="Unidade DAF"
                  value={formFluxoProaq.coordenacao}
                  onChange={handleChange}
                  disabled={true}
                  // disabled={false}
                />
              </CustomCol>

              <CustomCol>
                <Input
                  id="nomeModelo"
                  name="nomeModelo"
                  label="Nome do Modelo"
                  value={formFluxoProaq.nomeModelo}
                  onChange={handleChange}
                  // disabled={isModeloPadraoOuAssociadoAProaq()}
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow
              style={{ marginTop: '15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="250px">
                <Input
                  disabled={isModeloPadraoOuAssociadoAProaq()}
                  id="processoSei"
                  name="processoSei"
                  label="Nº do Processo SEI"
                  value={formFluxoProaq.processoSei}
                  onChange={handleChange}
                  mascara="99999.999999/9999-99"
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  disabled={isModeloPadraoOuAssociadoAProaq()}
                  id="documentoSei"
                  name="documentoSei"
                  label="Nº do Documento SEI"
                  value={formFluxoProaq.documentoSei}
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  disabled={isModeloPadraoOuAssociadoAProaq()}
                  id="link"
                  name="link"
                  label="Link do Documento de Especificações"
                  value={formFluxoProaq.link}
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow
              style={{ marginTop: '15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="100%">
                <Input
                  disabled={isModeloPadraoOuAssociadoAProaq()}
                  id="descricao"
                  name="descricao"
                  label="Descrição do Modelo"
                  value={formFluxoProaq.descricao}
                  onChange={handleChange}
                  type="textarea"
                  linhas={7}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow
              style={{ marginTop: '15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="100%">
                <Input
                  disabled={isModeloPadraoOuAssociadoAProaq()}
                  id="observacoes"
                  name="observacoes"
                  label="Observações"
                  value={formFluxoProaq.observacoes}
                  onChange={handleChange}
                  type="textarea"
                  linhas={3}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo
            boxTitulo="Fases do Fluxo"
            fechado={fichaID !== 'undefined' ? false : true}
          >
            <Tabela
              headers={headers}
              dataTable={tableDataFases}
              displayValues={valoresExibidos}
              onRowClick={handleRowClickFluxoFase}
              dataOffCanvas={offCanvasFases}
              botaoAbrirOffCanvas={false}
              showPagination={false}
              rowClickable={fichaID == '1' ? false : true}
            />
            <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
              <CustomButton
                label="Nova Fase do Fluxo"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={() => {
                  setUpdatingFluxoFase(false);
                  handleShowModalFluxoFase();
                }}
                disabled={
                  proaqBool ? true : fichaID === 'undefined' ? true : false
                }
              />
            </CustomCol>
          </BoxConteudo>

          {/* Modal Fluxo Fase */}
          <Modal
            tituloModal="Fase do Fluxo"
            open={showModalFluxoFase}
            onHide={handleShowModalFluxoFase}
          >
            <WorkspaceFicha>
              <Log
                {...logFluxoFase}
                entity="TB_FLUXO_PROAQ_FASE"
                id={Number(logFluxoFase?.id)}
              />
              <BoxConteudo boxTitulo="Dados da Fase">
                <CustomRow style={{ marginTop: '-15px' }}>
                  <CustomCol width="100px">
                    <Input
                      id="ordem"
                      name="ordem"
                      value={
                        updatingFluxoFase ? formFluxoFase.ordem : proximaFase
                      }
                      label="Nº Ordem"
                      onChange={handleChangeFluxoFase}
                      textAlign="right"
                      required
                      readonly
                    />
                  </CustomCol>
                  <CustomCol width="140px">
                    <Input
                      id="estimativaDias"
                      name="estimativaDias"
                      value={formFluxoFase.estimativaDias}
                      // value={Number(logFluxoFase?.id)}
                      label="Estimativa - dias"
                      onChange={handleChangeFluxoFase}
                      textAlign="right"
                      required
                    />
                  </CustomCol>
                  <CustomCol width="165px">
                    <Input
                      id="areaResponsavel"
                      name="areaResponsavel"
                      value={
                        updatingFluxoFase
                          ? formFluxoFase.areaResponsavel
                          : transformarEnumOptionValueEmLabel(
                              formFluxoProaq.coordenacao,
                              unidadeDAF,
                            )
                      }
                      label="Área Responsável"
                      onChange={handleChangeFluxoFase}
                      textAlign="right"
                      disabled
                    />
                  </CustomCol>
                  <CustomCol>
                    <Input
                      id="nomeFase"
                      name="nomeFase"
                      value={formFluxoFase.nomeFase}
                      label="Nome da Fase"
                      onChange={handleChangeFluxoFase}
                      required
                    />
                  </CustomCol>
                </CustomRow>
                <CustomRow style={{ marginTop: '15px' }}>
                  <CustomCol>
                    <Input
                      id="descricao"
                      name="descricao"
                      value={formFluxoFase.descricao}
                      label="Descrição"
                      onChange={handleChangeFluxoFase}
                      type="textarea"
                      linhas={8}
                    />
                  </CustomCol>
                </CustomRow>
                <CustomRow style={{ marginTop: '15px' }}>
                  <CustomCol>
                    <Input
                      id="observacoes"
                      name="observacoes"
                      value={formFluxoFase.observacoes}
                      label="Observações"
                      onChange={handleChangeFluxoFase}
                      type="textarea"
                      linhas={3}
                    />
                  </CustomCol>
                </CustomRow>
              </BoxConteudo>

              <BarraInferiorBotoes>
                {updatingFluxoFase ? (
                  <WorkspaceBotoes
                    delete
                    onClickDelete={handleDeleteFluxoFase}
                    deleteDisabled={proaqBool}
                    save
                    onClickSave={handleUpdateFluxoFase}
                    saveDisabled={isModeloPadraoOuAssociadoAProaq()}
                  />
                ) : (
                  <WorkspaceBotoes
                    inserir
                    onClickInserir={handleCreateFluxoFase}
                  />
                )}
              </BarraInferiorBotoes>
            </WorkspaceFicha>
          </Modal>
        </WorkspaceFicha>
      </ContainerConteudo>
      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            deleteDisabled={proaqBool}
            onClickDelete={handleDelete}
            save
            saveDisabled={!canSave}
            onClickSave={
              fichaID !== '1'
                ? handleUpdate
                : () =>
                    swalAttention(
                      'O <b>MODELO PADRÃO</b> não pode ser modificado!',
                    )
            }
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
